import React, { ReactNode, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../../../services/firebase";
import { LoadingOverlay } from "../../commons/LoadingOverlay";
import { useAuthState } from "react-firebase-hooks/auth";
import { AccountLoadingContext } from "../../../context/accountLoadingContext";

interface Props {
  children: ReactNode;
}

export const ProtectedRoute = ({ children }: Props) => {
  const [user, loading, error] = useAuthState(auth);
  const { accountLoading: accountLoading } = useContext(
    AccountLoadingContext
  );

  const navigate = useNavigate();

  useEffect(() => {
    if (
      user === null &&
      loading === false &&
      accountLoading === false
    ) {
      navigate("/logga-in");
    }
  }, [user, loading, accountLoading]);

  return <>{loading || user === undefined ? null : children}</>;
};
